import React, { useContext, useEffect } from 'react';
import { AppSettings } from '../../config/app-settings';

const Profile = React.memo(() => {
    const context = useContext(AppSettings);

    useEffect(() => {
        context.setAppHeaderNone(false);
        context.setAppSidebarNone(false);
        context.setAppContentClass('');
        context.setAppThemePanal(true);

        return () => {
            context.setAppHeaderNone(true);
            context.setAppSidebarNone(true);
            context.setAppContentClass('p-0');
            context.setAppThemePanal(false);
        };
    }, [context]); // Add context as a dependency

    return (
        <div>
            <div className="row">
                Profile
            </div>
        </div>
    );
});

export default Profile;
